import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createSlots as _createSlots, TransitionGroup as _TransitionGroup, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-1f5b2c56"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = /*#__PURE__*/_createTextVNode("Try again");

var _hoisted_2 = {
  key: 1,
  class: "notifications"
};
import { LoaderState } from "@/types/generic";
import { NotificationType } from "@/types/models/notification";
import NotificationItem from "@/components/notifications/NotificationItem.vue";
import Avatar from "@/components/users/Avatar.vue";
export default /*#__PURE__*/_defineComponent({
  props: {
    notifications: {
      default: function _default() {
        return [];
      }
    },
    loader: null,
    title: null,
    error: {
      default: "The requested data is currently inaccessible."
    },
    empty: {
      default: "There isn't any notifications."
    }
  },
  emits: ["retry"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    return function (_ctx, _cache) {
      var _component_n_h4 = _resolveComponent("n-h4");

      var _component_n_badge = _resolveComponent("n-badge");

      var _component_n_list_item = _resolveComponent("n-list-item");

      var _component_n_list = _resolveComponent("n-list");

      var _component_n_empty = _resolveComponent("n-empty");

      var _component_n_button = _resolveComponent("n-button");

      var _component_n_result = _resolveComponent("n-result");

      var _component_n_skeleton = _resolveComponent("n-skeleton");

      return __props.loader !== _unref(LoaderState).Loading ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [__props.loader !== _unref(LoaderState).Failed ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [__props.notifications.length > 0 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [__props.title ? (_openBlock(), _createBlock(_component_n_h4, {
        key: 0,
        class: "list-header d-flex flex-row align-items-center m-0 px-3"
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(__props.title), 1)];
        }),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_component_n_list, {
        class: "my-0 messages"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_TransitionGroup, {
            name: "list"
          }, {
            default: _withCtx(function () {
              return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.notifications, function (notification) {
                return _openBlock(), _createElementBlock("div", {
                  class: "n-list-item-shape",
                  key: notification.userNotificationId
                }, [_createVNode(_component_n_list_item, {
                  class: _normalizeClass(["align-items-start p-3", {
                    'read': !notification.status
                  }])
                }, _createSlots({
                  default: _withCtx(function () {
                    return [_createVNode(NotificationItem, {
                      notification: notification
                    }, null, 8, ["notification"])];
                  }),
                  _: 2
                }, [notification.type === _unref(NotificationType).GroupInvite ? {
                  name: "prefix",
                  fn: _withCtx(function () {
                    return [_createVNode(Avatar, {
                      user: notification.payload.user,
                      size: 42,
                      class: "mt-1"
                    }, null, 8, ["user"])];
                  })
                } : undefined, !notification.status ? {
                  name: "suffix",
                  fn: _withCtx(function () {
                    return [_createVNode(_component_n_badge, {
                      size: "large",
                      dot: "",
                      type: "error"
                    })];
                  })
                } : undefined]), 1032, ["class"])]);
              }), 128))];
            }),
            _: 1
          })];
        }),
        _: 1
      })], 64)) : _renderSlot(_ctx.$slots, "empty", {
        key: 1
      }, function () {
        return [_createVNode(_component_n_empty, {
          description: __props.empty
        }, null, 8, ["description"])];
      })], 64)) : (_openBlock(), _createBlock(_component_n_result, {
        key: 1,
        size: "small",
        status: "error",
        title: "Error",
        description: __props.error
      }, {
        footer: _withCtx(function () {
          return [_createVNode(_component_n_button, {
            onClick: _cache[0] || (_cache[0] = function ($event) {
              return emit('retry');
            })
          }, {
            default: _withCtx(function () {
              return [_hoisted_1];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["description"]))], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_n_list, {
        class: "my-0 messages"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, function (n) {
            return _createVNode(_component_n_list_item, {
              class: "align-items-start p-3",
              key: n
            }, {
              default: _withCtx(function () {
                return [_createVNode(_component_n_skeleton, {
                  class: "line-1"
                }), _createVNode(_component_n_skeleton, {
                  class: "line-2 mt-2"
                }), _createVNode(_component_n_skeleton, {
                  class: "meta mt-3"
                })];
              }),
              _: 2
            }, 1024);
          }), 64))];
        }),
        _: 1
      })]));
    };
  }
});